import { render, staticRenderFns } from "./EstoqueLista.vue?vue&type=template&id=6b3541ba&scoped=true&"
import script from "./EstoqueLista.vue?vue&type=script&lang=js&"
export * from "./EstoqueLista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3541ba",
  null
  
)

export default component.exports